export default __webpack_public_path__ + "static/media/nightDisabled.39245b15.svg";